export default "__VITE_ASSET__CBtq1x9x__"